import { Browser } from '@capacitor/browser'
import { useEffect } from 'react'
import { App, URLOpenListenerEvent } from '@capacitor/app'
import { pushFx } from '~/shared/lib/history'

export function AppUrlListener() {
  useEffect(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      let router: string | undefined

      if (event.url.startsWith('apark://')) {
        // apark://host?query или apark:///path?query → /path?query
        router = event.url.replace(/^apark:\/+/, '/')
      } else {
        // https://driver.apark.pro/path?query → /path?query
        router = event.url.split('.pro').pop() ?? undefined
      }

      // На iOS in-app браузер (SFSafariViewController) — модальное окно
      // поверх приложения и сам не закрывается, когда приложение обработало
      // диплинк. Без явного закрытия пользователь продолжает видеть
      // браузер, хотя переход внутри приложения уже произошёл.
      Browser.close().catch(() => undefined)

      if (router) {
        pushFx(router)
      }
    })
  }, [])

  return null
}
